export class PaymentRequest {
  reference: string;
  clientId: string;
  userId: string;
  amount: number;
  currency: string;
  callbackUrl: string;
  bankCode: string;
  paymentChannel: string;
  paymentUrl: string;
}

export class MOMORequest {
  reference: string;
  clientId: string;
  userId: string;
  amount: number;
  currency: string;
  callbackUrl: string;
  provider: string;
  paymentChannel: string;
  paymentUrl: string;
}

export class CreatePaymentReqest {
  reference: string;
  clientId: string;
  userId: string;
  amount: number;
  currency: string;
  callbackUrl: string;
  redirectUrl: string;
  metadata: Metadata;
  extraFields?: any;
}

export class MakePaymentRes {
  reference: string;
  clientId: string;
  paymentUrl: string;
  status: string;
  providerResponse: string;
}
export interface Metadata {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  descr: string;
  address: string;
  currency: string;
  itemCode: string;
  productName: string;
  amount: string;
}
